export type ValueType = string | number | boolean | Object | unknown[] | undefined;
export interface PersistQueryParamsKeyConfig<VALUE_TYPE extends ValueType = ValueType> {
	type?: 'string' | 'number' | 'boolean' | 'object' | 'array';
	keyName?: string;
	sessionStorageKeyPrefix?: string;
	localStorageKey?: string;
	defaultValue?: VALUE_TYPE;
	customSerializer?: {
		isValueEmpty?: (value: VALUE_TYPE) => boolean;
		serialize?: (value: VALUE_TYPE) => string;
		deserialize?: (value: string | null) => VALUE_TYPE;
		isDefault?: (value: VALUE_TYPE, defaultValue?: VALUE_TYPE) => boolean;
	};
}
export type IndexableObject = {
	[k: string]: ValueType;
};
export type PersistQueryParamsConfig<
	STORE extends STORE_STATE,
	STORE_STATE extends IndexableObject = StoreState<STORE>,
> = {
	[KEY in keyof STORE_STATE]?: PersistQueryParamsKeyConfig<STORE_STATE[KEY]>;
};

export type UnIndexableKeys = 'actions' | 'internalActions';
export type StoreState<STORE> = Omit<STORE, UnIndexableKeys>;

export const TITLE_REPORT_KEY = 'title-report';
export const CHILDREN_LIST_KEY = 'children-list';
export const OBJECT_BROWSER_KEY = 'object-browser';
export const TITLE_OBJECTS_TAB_OBJECT_BROWSER_KEY = 'title-objects-tab-object-browser';
